// V2 Shared Components for Opportunity Detail Pages
// ============================================================================

// Primitives
export { BadgeV2 } from './BadgeV2'
export type { BadgeV2Props, BadgeVariant } from './BadgeV2'

export { DataBlockV2 } from './DataBlockV2'
export type {
  DataBlockV2Props,
  DataBlockIconProps,
  DataBlockLabelProps,
  DataBlockValueProps,
  DataBlockSubValueProps,
} from './DataBlockV2'

export { Timeline } from './TimelinePrimitive'
export type {
  TimelineRootProps,
  TimelineItemProps,
  TimelineDotProps,
  TimelineContentProps,
} from './TimelinePrimitive'

export { TimelineV2 } from './TimelineV2'
export type { TimelineV2Props, TimelineNodeProps } from './TimelineV2'

export { TabPanelV2 } from './TabPanelV2'
export type {
  TabPanelV2Props,
  TabListProps,
  TabTriggerProps,
  TabContentProps,
} from './TabPanelV2'

// Composed
export { SidebarWidgetV2 } from './SidebarWidgetV2'
export type {
  SidebarWidgetV2Props,
  SidebarWidgetHeaderProps,
  SidebarWidgetContentProps,
} from './SidebarWidgetV2'

export { FileCardV2 } from './FileCardV2'
export type {
  FileCardV2Props,
  FileCardTriggerProps,
  FileCardIconProps,
  FileCardTitleProps,
  FileCardMetaProps,
  FileCardActionsProps,
  FileCardContentProps,
} from './FileCardV2'

// Layout
export { BreadcrumbsV2 } from './BreadcrumbsV2'
export type { BreadcrumbsV2Props, BreadcrumbItem } from './BreadcrumbsV2'

export { PageTitleV2 } from './PageTitleV2'
export type { PageTitleV2Props } from './PageTitleV2'

// Shared DisplayV2 Components
export { OpportunityFileCard } from './OpportunityFileCard'
export type {
  OpportunityFile,
  OpportunityFileCardProps,
} from './OpportunityFileCard'

export { ViewDocumentsButton } from './ViewDocumentsButton'
export type { ViewDocumentsButtonProps } from './ViewDocumentsButton'

export { DocumentsSection } from './DocumentsSection'
export type { DocumentsSectionProps } from './DocumentsSection'

export {
  OpportunityDocumentsSection,
  OpportunityDocumentsTab,
} from './OpportunityDocumentsViewer'
export type {
  OpportunityDocumentsSectionProps,
  OpportunityDocumentsTabProps,
} from './OpportunityDocumentsViewer'

export { ShareIcon } from './ShareIcon'
export type { ShareIconProps } from './ShareIcon'

// Place of Performance
export { PlaceOfPerformanceV2 } from './PlaceOfPerformanceV2'
export type { PlaceOfPerformanceV2Props } from './PlaceOfPerformanceV2'

// Related Content
export { SimilarOpportunitiesV2 } from './SimilarOpportunitiesV2'
export type {
  SimilarOpportunitiesRootProps,
  SimilarOpportunitiesHeaderProps,
  SimilarOpportunitiesGridProps,
  SimilarOpportunitiesCardProps,
  SimilarOpportunitiesEmptyProps,
  SimilarOpportunitiesSkeletonProps,
} from './SimilarOpportunitiesV2'

// Data Display
export {
  DataSheet,
  DataSheetFromData,
  DataSheetSkeleton,
  toTitleCase,
} from './DataSheet'
export type {
  DataSheetProps,
  DataSheetVariant,
  DataSheetSectionProps,
  DataSheetRowProps,
  DataSheetEmptyStateProps,
  DataSheetSkeletonProps,
  DataSheetRowData,
  DataSheetSectionData,
} from './DataSheet'
